<template>
  <div class="grid">
    <div class="common-title" id="CORE-COMPETENCE">
      <div class="common-title-content">
        核心能力
      </div>
    </div>
    <div class="core-competence-show">
      <div class="core-competence-panels">
        <div
          class="core-competence-panel"
          :class="currentTab == index ? 'active' : ''"
          @mouseenter="handleTabChange(index)"
          v-for="(panel, index) in panels"
          :key="index"
        >
          <h4>{{ panel.title }}</h4>
          <p class="animated fadeInUp">{{ panel.sub }}</p>
        </div>
      </div>
      <div class="core-competence-des">
        <div class="core-des-img" v-show="currentTab == 0">
          <img src="@/assets/images/coreCompetence/building.png" />
        </div>
        <div class="core-des-img" v-show="currentTab == 1">
          <img src="@/assets/images/coreCompetence/scene.png" />
        </div>
        <div class="core-des-img" v-show="currentTab == 2">
          <img src="@/assets/images/coreCompetence/system.png" />
        </div>
        <div class="core-des-img" v-show="currentTab == 3">
          <img src="@/assets/images/coreCompetence/application.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "coreCompetence",
  data() {
    return {
      panels: [
        {
          title: "城市微场景行业理解能力",
          sub:
            "随着长期市场探索和沉淀，公司对智慧城市微场景尤其是智慧社区形成了自身独特的认知，并不断进行技术和方案更迭，以适应不同场景需求和市场趋势。"
        },
        {
          title: "微场景数据边缘接入能力",
          sub:
            "支持多种类型物联网感知设备泛在接入，拥有全系列物联网生态链条，依托集网络、计算、存储、应用等能力为一体的边缘计算应用平台，为用户提供实时、动态和智能的数据处理服务。"
        },
        {
          title: "物联网数据中台计算能力",
          sub:
            "自主研发出城市级物联网大数据中台，保障海量数据处理能力，构建智慧城市微场景数据大脑，助力智慧城市微场景实战应用。"
        },
        {
          title: "微场景数据资源应用能力",
          sub:
            "围绕基层社会治理需求，瞄准场景痛点和难点问题，结合数据中台和社区大脑的强大算力，用数据赋能社会治理和社区运营。"
        }
      ],
      currentTab: 0
    };
  },
  methods: {
    handleTabChange(idx) {
      this.currentTab = idx;
    }
  }
};
</script>

<style lang="less" scoped>
.grid {
  .core-competence-show {
    padding: 0 5rem;
    display: flex;
    justify-content: center;
    .core-competence-panels {
      margin-right: 1rem;
      .core-competence-panel {
        width: 37.15rem;
        height: 8.5rem;
        padding-left: 2.85rem;
        padding-right: 6.6rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-bottom: 2rem;
        color: #333333;
        background-image: url("~@/assets/images/coreCompetence/panel.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        transition: height 0.5s ease;
        &.active {
          height: 13.9rem;
          color: #ffffff;
          background-image: url("~@/assets/images/coreCompetence/cor_panel.png");
          p {
            display: block;
          }
        }
        &:last-child {
          margin-bottom: 0 !important;
        }
        h4 {
          font-size: 1.05rem;
          font-weight: 600;
          line-height: 1.45rem;
        }
        p {
          display: none;
          margin-top: 1rem;
          font-size: 0.9rem;
          line-height: 1.4rem;
          text-align: justify;
          animation: 1s ease fadeInUp;
        }
      }
    }
    .core-competence-des {
      font-size: 0;
      img {
        width: 46.6rem;
        height: 45.4rem;
      }
    }
  }
}
</style>
